// !!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! GENERATED FILE. Do not edit manually. Run bin/generateLocalizedStrings.js instead
// !!!!!!!!!!!!!!!!!!!!!!!!!!!
/* eslint-disable quotes */
export default {
  "ABOUT": "Tema",
  "ABOUT_API_TAB": "API",
  "ABOUT_VERSION": "Versione",
  "ABOUT_EXTENSIS_URL": "www.portfoliodam.com",
  "ABOUT_PORTFOLIO_SERVER": "Portfolio Server",
  "ABOUT_PORTFOLIO_VERSION": "Versione 9.0",
  "ABOUT_SERVER_TAB": "Server",
  "accessOriginals": "Accedi agli originali ed elaborali",
  "ACCOUNT_TYPE": "Autenticazione",
  "ACCOUNT_TYPE_LDAP": "Servizio Directory",
  "ACCOUNT_TYPE_MANUAL": "Nativo (incorporato)",
  "ACTIVE_DIRECTORY": "Active Directory",
  "ADD": "Aggiungi",
  "ALL_CATALOGS_GROUP": "Tutti i cataloghi",
  "API_CODE_REFERENCE": "Riferimento codice API (English)",
  "API_CODE_REFERENCE_URL": "https://doc.portfoliodam.com/api/portfolio/index.html",
  "API_DEVELOPER_COMMUNITY": "Community degli sviluppatori",
  "API_DEVELOPER_COMMUNITY_URL": "https://forums.portfoliodam.com/c/digital-asset-management/portfolio-api-developer-community",
  "API_PORTFOLIO_HELP": "Guida di Portfolio Administration",
  "API_PORTFOLIO_HELP_URL": "https://helpdocs.portfoliodam.com/en/portfolio/administration/{version}/index.htm",
  "API_SECTION_1": "L'API di Portfolio fornisce agli sviluppatori un'interfaccia comune per integrare i cataloghi di Portfolio, i metadati degli asset e l'elaborazione dei media nei sistemi aziendali, nei flussi di lavoro personalizzati e nelle infrastrutture web.",
  "API_SECTION_2_PART_1": "Per utilizzare l'API sono necessarie delle licenze, come descritto ",
  "API_SECTION_2_EULA": "nell'EULA di Portfolio",
  "API_SECTION_2_EULA_URL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/en/Content/Legal/extensis-portfolio-eula.htm",
  "API_SECTION_2_PART_2": ". Per visualizzare o modificare le informazioni su una licenza, fare clic su 'Licenze' nell'applicazione Portfolio Administration.",
  "API_SECTION_2_PART_3": "Per sapere di più:",
  "API_TOKEN_CREATE": "Aggiungi nuovo Token API",
  "APPLY": "Applica",
  "APP_PAGE_TITLE": "Portfolio Admin",
  "AT_TIME": "alle ore",
  "AUTHENTICATION_ERROR": "Autenticazione servizio directory non riuscita. Controllare nome utente e password.",
  "BACKUP_BACKUP_BUTTON": "Backup",
  "BACKUP_BACKUP_LABEL": "Backup",
  "BACKUP_BACKUP_NOW_BUTTON": "Esegui il backup adesso",
  "BACKUP_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Per cambiare la posizione di backup, spegnere prima il server del Portfolio.",
  "BACKUP_CONFIRMATION_VERBIAGE": "Esegui il backup adesso? Il Portfolio sarà offline fino a quando il backup non è completo.",
  "BACKUP_DIRECTORY_LABEL": "Archivia nella directory",
  "BACKUP_DIRECTORY_ERROR_MSG": "La directory di backup selezionata non è valida.",
  "BACKUP_EXPLANATION_TEXT_1": "Con il backup si acquisiscono e si archiviano i database del server e le impostazioni in modo sicuro.\nlt non esegue il backup dei file delle risorse originali!",
  "BACKUP_EXPLANATION_TEXT_2": "Non sarà possibile accedere al server durante i backup.",
  "BACKUP_FRIDAY_LABEL": "Venerdì",
  "BACKUP_MONDAY_LABEL": "Lunedì",
  "BACKUP_MOST_RECENT_LABEL": "Il backup più recente",
  "BACKUP_NEXT_SCHEDULED_LABEL": "Prossimo backup pianificato",
  "BACKUP_NOTIFICATIONS": "Inviare una notifica per e-mail dopo backup e ripristini",
  "BACKUP_NOTIFICATIONS_DISABLED_MSG": "Notifiche via e-mail deve essere abilitato in Impostazioni globali > Notifiche via e-mail",
  "BACKUP_PROGRESS_BACKING_UP": "Backup in corso",
  "BACKUP_PROGRESS_BACKING_UP_DATA": "Backup dei dati in corso...",
  "BACKUP_PROGRESS_BACKUP_CANCELLED": "Backup cancellato",
  "BACKUP_PROGRESS_BACKUP_FAILED": "Backup non riuscito",
  "BACKUP_PROGRESS_BACKUP_SUCCESSFUL": "Backup eseguito con successo",
  "BACKUP_PROGRESS_PREFLIGHT": "Controllo spazio disponibile...",
  "BACKUP_PROGRESS_RESTARTING": "Riavvio server in corso...",
  "BACKUP_PROGRESS_RESTORE_FAILED": "Ripristino fallito",
  "BACKUP_PROGRESS_RESTORE_SUCCESSFUL": "Ripristino eseguito con successo",
  "BACKUP_PROGRESS_RESTORING": "Ripristino in corso",
  "BACKUP_PROGRESS_RESTORING_DATA": "Ripristino dati in corso...",
  "BACKUP_PROGRESS_SHUTTING_DOWN": "Spegnimento server in corso...",
  "BACKUP_PROGRESS_SUMMARY": "Passaggio {stepNum} di {totalSteps}",
  "BACKUP_RESTORE_BUTTON": "Ripristino dal file di backup in corso...",
  "BACKUP_RESTORE_CONFIRMATION_VERBIAGE": "Ripristinare il backup adesso? Il Portfolio sarà offline fino a quando il ripristino non è completo. Il database e le impostazioni correnti verranno sovrascritte.",
  "BACKUP_RESTORE_ERROR_MSG_BAD_ARCHIVE": "L'archivio di backup è danneggiato. Scegli un altro backup da cui eseguire il ripristino.",
  "BACKUP_RESTORE_ERROR_MSG_INSUFFICIENT_SPACE": "Lo spazio nel disco di backup non è sufficiente\nper completare.\n\n{requiredSpace} necessari, {availableSpace} disponibili.",
  "BACKUP_RESTORE_ERROR_MSG_INVALID_BACKUP_DIRECTORY": "La posizione di backup correntemente configurata non esiste. La posizione di backup è utilizzata per decomprimere l’archivio quando un backup è in ripristino. Ripristina la posizione di backup in una directory valida.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_BACKUP": "Si è verificato un problema con il backup. Consultare i registri admin per i dettagli.",
  "BACKUP_RESTORE_ERROR_MSG_UNRECOVERABLE_RESTORE": "Si è verificato un problema con il ripristino. Consultare i registri admin per i dettagli.",
  "BACKUP_RESTORE_LABEL": "Ripristino",
  "BACKUP_RESTORE_TITLE": "Backup/Ripristino",
  "BACKUP_RETAIN_LABEL": "Conserva",
  "BACKUP_RETAIN_VALUE": "Tenere solo i {numBackups} backup più recenti",
  "BACKUP_SATURDAY_LABEL": "Sabato",
  "BACKUP_SCHEDULE_LABEL": "Pianifica i backup",
  "BACKUP_SCHEDULE_VALUE": "il",
  "BACKUP_SUNDAY_LABEL": "Domenica",
  "BACKUP_THURSDAY_LABEL": "Giovedì",
  "BACKUP_TUESDAY_LABEL": "Martedì",
  "BACKUP_WEDNESDAY_LABEL": "Mercoledì",
  "BROWSE": "Sfoglia",
  "BROWSE_FOLDERS_TITLE": "Sfoglia le cartelle del server",
  "BROWSE_RECENT_FOLDERS_LABEL": "Cartelle recenti",
  "BROWSE_REFRESH": "Sincronizza articoli",
  "CALL_ATT_BUTTON_BUY_NOW": "Acquista ora",
  "CALL_ATT_BUTTON_SECONDARY": "Contatta l'ufficio vendite per un preventivo",
  "CALL_ATT_FADEL_BUTTON_MAIN": "Vendite del contatto per più informazioni",
  "CALL_ATT_FADEL_MAIN": "Assicurati un uso corretto dei contenuti soggetti a licenza, dalle immagini ai video e tutto ciò che comprendono. Portfolio si collega senza problemi al software FADEL Rights Cloud in modo da poter vedere e comprendere facilmente l'uso di diritti associati alle proprie risorse—aiutandoti a rimuovere le strettorie del flusso di lavoro e ridurre il rischio di violazioni del diritto d'autore.",
  "CALL_ATT_FADEL_SUBTITLE": "Conosci i tuoi diritti di uso delle risorse",
  "CALL_ATT_FADEL_TITLE": "FADEL RIGHTS CLOUD",
  "CALL_ATT_ME_SUBTITLE": "Gestione e conversione ad alte prestazioni",
  "CALL_ATT_ME_MAIN": "Spingere i limiti prestazionali del proprio server Portfolio? Con Media Engine, si evitano rallentamenti e si migliora la produttività generale eliminando i colli di bottiglia causati da ambienti di produzione sovraccarichi.\n\n\t• Aumenta rendimento e velocità\n\t• Sblocca formati di uscita aggiuntivi\n\t• Accelera creazione anteprima video\n\t• Aggiungi più motori multimediali secondo necessità\n\t• Filigrana (richiede NetPublish)",
  "CALL_ATT_ME_BUTTON_MAIN": "Ottieni Media Engine",
  "CALL_ATT_NP_SUBTITLE": "Portali Self-Service per accedere immediatamente agli asset",
  "CALL_ATT_NP_MAIN": "Stanco di quelle richieste last minute ogni volta che qualcuno ha bisogno di un asset? Con NetPublish, è molto semplice pubblicare siti web self service che consentono a tutti di individuare e scaricare gli asset di cui hanno bisogno da qualsiasi browser su qualsiasi dispositivo.\n\n\t• Creazione di siti con un click: nessun HTML o CSS necessario\n\t• Design rapido e ottimizzato per dispositivi mobili\n\t• Controllo accesso utente flessibile\n\t• Disattiva siti automaticamente\n\t• Imposta risoluzione, dimensioni e formato al momento del download\n\t• Filigrana (richiede Media Engine)\n\t• Rapporto utilizzo",
  "CALL_ATT_NP_BUTTON_MAIN": "Ottieni NetPublish",
  "CALL_ATT_REPORT_TITLE": "Report per NetPublish",
  "CALL_ATT_REPORT_SUBTITLE": "Verifica uso rilevante",
  "CALL_ATT_REPORT_MAIN": "Vuoi sapere quali siti sono più attivi, quali asset sono usati e da chi? Con il report NetPublish, ottieni le informazioni di cui hai bisogno per prendere decisioni informate in base a come il Portfolio è usato nella tua organizzazione.\n\nAnalisi uso da:\n\t• Nome sito NetPublish\n\t• Nome utente\n\t• Nome asset e ID\n\t• Data e ora",
  "CALL_ATT_REPORT_BUTTON_MAIN": "Ottieni NetPublish",
  "CALL_ATT_SK_BUTTON_MAIN": "Prova gratis",
  "CALL_ATT_SK_BUTTON_TRY_NOW": "https://extens.is/wqqb",
  "CALL_ATT_SK_MAIN": "Cercare un modo di accelerare il proprio processo di assegnazione di parole chiave a immagini? Con Portfolio Smart Keyword, è possibile assegnare automaticamente parole chiave \"smart\" alle proprie immagini con un solo clic. Sponsorizzato da Clarifai, una società innovativa di licenza artificiale che eccelle nella tecnologia di riconoscimento visivo, un elenco di parole chiave suggerito è fornito in secondi.\n\n\t• Fornisce un elenco di smart keyword in secondi\n\t• Fa risparmiare tempo e risorse riducendo le parole chiave manuali\n\t• Stabilisce una tassonomia consistente per la propria organizzazione\n\t• Rende semplice trovare le risorse rapidamente.",
  "CALL_ATT_SK_SUBTITLE": "Automatizzare la creazione di parole chiave per la tua immagine",
  "CALL_ATT_SK_TITLE": "Portfolio Smart Keyword",
  "CALL_ATT_SSO_SUBTITLE": "Esperienza utente unica trasversale a tutte le piattaforme",
  "CALL_ATT_SSO_TITLE": "Accesso singolo",
  "CALL_ATT_SSO_MAIN": "I membri della tua organizzazione stanno avendo difficoltà nel gestire le loro credenziali di accesso? Solitamente, le nuove soluzioni sono corredate da informazioni extra per la gestione degli account, utilizzabili da te e dagli utenti finali..\n\nFortunatamente, il Portfolio supporta l’accesso singolo con directory attiva. Utilizzando l'accesso singolo, gli utenti possono accedere automaticamente al Portfolio dal proprio sito intranet e ricevere un'esperienza utente continua.\n\n\t• Supporta Windows Server Active Directory\n\t• Migliora la sicurezza generale\n\t• Semplifica gestione utente\n\t• Migliora l'esperienza dell'utente",
  "CALL_ATT_SSO_BUTTON_MAIN": "Ottieni accesso singolo",
  "CALL_ATT_URL_BUY_NOW": "https://secure.portfoliodam.com/portfolio-options?lang=it",
  "CALL_ATT_URL_CONTACT_SALES": "https://portfoliodam.com/portfolio/contact-me",
  "canEmbedMetadata": "Nidifica Metadati",
  "canImportMetadata": "Importa/Esporta dati",
  "canManagePublicGallery": "Gestisci gallerie pubbliche",
  "canPublishNetPublishSites": "Può pubblicare siti NetPublish",
  "canSmartKeyword": "Può Smart Keyword",
  "CANCEL": "Annulla",
  "CATALOG": "Cataloga",
  "CATALOG_ADD_SELECTED_USERS_TO_CATALOG": "Concedi membership",
  "CATALOG_BACKUP": "Esegui backup del catalogo selezionato",
  "CATALOG_CREATE": "Aggiungi nuovo catalogo",
  "CATALOG_CREATE_AUTOSYNC_DISABLED_INFO_MSG": "Gli amministratori di catalogo possono aggiungere cartelle AutoSync dal Desktop Client.",
  "CATALOG_CREATE_AUTOSYNC_FOLDER": "Creare una cartella AutoSync",
  "CATALOG_CREATE_CATALOG_TEMPLATE": "Modello di catalogo",
  "CATALOG_TYPE_GENERAL": "General Use",
  "CATALOG_TYPE_SIMPLE": "Simple",
  "CATALOG_CREATE_DATABASES_LIST_LABEL": "Database",
  "CATALOG_CREATE_ERROR_CREATING_FOLDERS": "Si è verificato un errore durante la creazione della cartella {folder}.",
  "CATALOG_CREATE_GLOBAL_SETTING_INFO_MSG": "Le cartelle predefinite AutoSync e Anteprima possono essere configurate nelle Impostazioni globali.",
  "CATALOG_CREATE_NAME": "Nome",
  "CATALOG_CREATE_PREVIEW_DISABLED_INFO_MSG": "Le anteprime possono essere visualizzate in Dettagli catalogo.",
  "CATALOG_CREATE_PREVIEW_FOLDER": "Salvare le anteprime per visualizzarle velocemente",
  "CATALOG_CREATE_SHOW_DATABASES": "Mostra database",
  "CATALOG_CREATE_USE_VERSIONING": "Utilizza Versione Asset",
  "CATALOG_DELETE": "Elimina catalogo",
  "CATALOG_DELETE_CONFIRM": "Eliminare il catalogo selezionato?",
  "CATALOG_DETAILS": "Dettagli catalogo",
  "CATALOG_DETAILS_CHANGE_NAME_PROMPT": "Per rinominare questo catalogo è necessario metterlo temporaneamente offline, si desidera continuare?",
  "CATALOG_DETAILS_COLLATION": "Fascicolazione",
  "CATALOG_DETAILS_COLLATION_NA": "N/D",
  "CATALOG_DETAILS_CREATION_DATE": "Data di creazione",
  "CATALOG_DETAILS_DATABASE_TAB": "Generale",
  "CATALOG_DETAILS_LAST_MODIFIED": "Ultima modifica",
  "CATALOG_DETAILS_NUMBER_OF_CONNECTED_USERS": "Utenti collegati",
  "CATALOG_DETAILS_NUMBER_OF_RECORDS": "Registrazioni",
  "CATALOG_DETAILS_NUMBER_OF_USERS": "Membri",
  "CATALOG_DETAILS_SIZE_ON_DISK": "Dimensione su disco",
  "CATALOG_DETAILS_WARN_DISCONNECT_ADMIN": "L'utente amministratore sarà scollegato. Procedere?",
  "CATALOG_DETAILS_LOCKED_FOR_ADMINISTRATION": "Bloccato per l'amministrazione",
  "CATALOG_DETAILS_UNLOCK": "Sblocca",
  "CATALOG_EXPLANATION_VAULT_1": "I cataloghi Vault conservano asset in depositi sicuri.",
  "CATALOG_EXPLANATION_VAULT_2": "I cataloghi Vault supportano blocco, versionamento, estrazione e archiviazione.",
  "CATALOG_EXPLANATION_WF_1": "I cataloghi Watch Folder monitorano asset presenti nel file system.",
  "CATALOG_EXPLANATION_WF_2": "Cataloghi Watch Folder supportano AutoSync.",
  "CATALOG_INGEST_DRAG_HINT_TEXT": "Per aggiungere campi al Modulo di upload, trascinarli dall'elenco Campi.",
  "CATALOG_INGEST_FIELDS_FOR_UPLOAD_FORM_LABEL": "Campi per Modulo di upload",
  "CATALOG_INGEST_FIELDS_LABEL": "Campi",
  "CATALOG_INGEST_FORM_HEADER_LABEL": "Intestazione modulo",
  "CATALOG_INGEST_HEADER_HINT_TEXT": "L'intestazione del modulo è opzionale e appare nella parte alta del modulo.",
  "CATALOG_INGEST_MAX_FIELDS_WARNING_MESSAGE": "Il numero massimo di campi da aggiungere a un modulo è {maxFields}.",
  "CATALOG_INGEST_TAB_TITLE": "Upload Gestito",
  "CATALOG_INGEST_USE_INGEST_LABEL": "Utilizza Upload gestito",
  "CATALOG_INGEST_REQUIRED_LABEL": "Necessario",
  "CATALOG_IS_CONNECTED": "Collegato",
  "CATALOG_IS_DEFAULT": "Predefinito",
  "CATALOG_MANAGE_USERS": "Gestisci membership catalogo",
  "CATALOG_MANAGE_FIELDS": "Gestisci campi catalogo",
  "CATALOG_MANAGE_TEMPLATES_MENU_LABEL": "Gestisci modelli di catalogo...",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_TITLE": "Gestisci modelli di catalogo personalizzati",
  "CATALOG_MANAGE_TEMPLATES_DIALOG_HEADER": "Nome modello di catalogo",
  "CATALOG_MEMBER": "Membro",
  "CATALOG_NEW_CATALOG_DETAILS": "Dettagli nuovo catalogo",
  "CATALOG_OFFLINE": "Offline",
  "CATALOG_ONLINE": "Online",
  "CATALOG_OPTIONS_ALL_FILE_TYPES": "Cataloga tutti i tipi di file",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_LABEL": "Crea parole chiave dal percorso",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_FILENAME": "Nome file",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_PARENT": "Cartella principale",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_SERVER": "Nome server",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_TREE": "Struttura ad albero cartelle",
  "CATALOG_OPTIONS_CREATE_KEYWORDS_OPT_VOLUME": "Volume",
  "CATALOG_OPTIONS_EXCLUSION_LABEL": "Esclusioni file e cartella",
  "CATALOG_OPTIONS_ONLY_FILE_TYPES": "Cataloga solamente",
  "CATALOG_OPTIONS_REMOVE_FILE_TYPES_CONFIRMATION": "Rimuovere il/i tipo/i di file selezionato/i? ",
  "endsWith": "Finisce con",
  "contains": "Contiene",
  "startsWith": "Inizia con",
  "CATALOG_OPTIONS_REMOVE_EXCLUSIONS_CONFIRMATION": "Rimuovere la/le esclusione/i selezionata/e?",
  "CATALOG_OPTIONS_TAB_TITLE": "Opzioni di catalogazione",
  "CATALOG_PREVIEWS_DEFAULT_LOCATION_IS": "La posizione predefinita è",
  "CATALOG_PREVIEWS_DIMENSIONS_LABEL": "Dimensioni minime 300 pixel, dimensioni massime 4000 pixel (dimensione più lunga)",
  "CATALOG_PREVIEWS_GENERATE_AUDIO_VIDEO_FILES": "Genera clip per file audio/video",
  "CATALOG_PREVIEWS_GENERATE_PREVIEWS": "Crea anteprime",
  "CATALOG_PREVIEWS_FOLDER_LOCATION": "Salva anteprime e clip in questa cartella",
  "CATALOG_PREVIEWS_LOCATION_WARNING_INFO": "Questa posizione deve essere accessibile al server.",
  "CATALOG_PREVIEWS_MAX_PIXELS": "Dimensione massima dell'immagine",
  "CATALOG_PREVIEWS_MAX_VIDEO_RESOLUTION": "Risoluzione video massima",
  "CATALOG_PREVIEWS_MINUTES": "minuti",
  "CATALOG_PREVIEWS_PIXELS": "pixel",
  "CATALOG_PREVIEWS_SHORT": "Anteprime",
  "CATALOG_PREVIEWS_VIDEO_LIMIT_DURATION": "Limita la durata a ",
  "CATALOG_PREVIEWS_VIDEO_CLIP_PROCESSING_INFO_TEXT": "La generazione di clip può richiedere un po' di tempo per l'elaborazione.\nPer accorciare il tempo di elaborazione, scegliere una risoluzione e una durata inferiori.",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG": "Annulla membership",
  "CATALOG_REMOVE_SELECTED_USERS_FROM_CATALOG_CONFIRMATION": "Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.",
  "CATALOG_SAVE_TEMPLATE": "Salva modello catalogo...",
  "CATALOG_SAVE_TEMPLATE_DETAILS_TEXT": "Il modello salvato include: tutti i campi, le mappature dei metadati e le impostazioni delle opzioni catalogo.",
  "CATALOG_SELECT_MESSAGE": "Nessun catalogo selezionato",
  "CATALOG_SET_AS_DEFAULT": "Imposta catalogo predefinito",
  "CATALOG_SK_DEFAULT_SETTINGS": "Impostazioni predefinite",
  "CATALOG_SK_CONFIDENCE_LEVEL_LABEL": "Livello di riservatezza",
  "CATALOG_SK_DEFAULT_LABEL": "Raccomandato: {recommended}",
  "CATALOG_SK_ENGINES_LABEL": "Motori di ricerca con Smart Keywords",
  "CATALOG_SK_LANGUAGES_LABEL": "Lingue per General Engine",
  "CATALOG_SK_NUM_KEYWORDS_LABEL": "Numero di parole chiave",
  "CATALOG_SK_SETTINGS_LABEL": "Impostazioni",
  "CATALOG_SK_TAB_TITLE": "Smart Keywords",
  "CATALOG_SK_USE_SK_LABEL": "Utilizzare Smart Keywords in questo catalogo",
  "CATALOG_STATUS": "Stato catalogo",
  "CATALOG_STORAGE_TYPE_LABEL": "Tipo di archiviazione",
  "CATALOG_STORAGE_TYPE_WATCHFOLDERS": "Guarda cartelle",
  "CATALOG_STORAGE_TYPE_VAULT": "Insieme di credenziali",
  "CATALOG_TAKE_OFFLINE_SHORT": "Porta offline",
  "CATALOG_TAKE_ONLINE_SHORT": "Porta online",
  "CATALOG_TEMPLATE": "modello",
  "CATALOG_TEMPLATE_NAME": "Nome modello",
  "CATALOG_TEMPLATES_TITLE": "Modelli di Catalogo",
  "CATALOG_TEMPLATE_REMOVE_CONFIRMATION": "Rimuovere il modello di catalogo selezionato?",
  "CATALOG_VIEW_DETAILS": "Visualizza/Modifica dettagli catalogo",
  "CERT_REQUEST_ALREADY_CREATED_WARNING": "Hai già creato una richiesta di certificato. Se continui, la richiesta esistente verrà eliminata.",
  "CERTIFICATE_FILE_FILTER": "Certificati (p7b, p7, cer, crt, pem, pfx, p12)",
  "CITY_OR_LOCALITY": "Città o località",
  "CLEAR_BUTTON_LABEL": "Cancella",
  "COMMUNICATION_AT_INITILIZATION_ERROR": "Si è verificato un errore durante la comunicazione con il server. Ciò in genere è dovuto alla presenza di dati non aggiornati nella cache del browser, ma può anche indicare un problema del server. Contattare l'amministratore per maggiori informazioni.",
  "CONFIGURE_DIRECTORY_SERVICE": "Configura Servizio Directory",
  "CONFIRM_DELETE_PDL": "Eliminare tutti i valori predefiniti per questo campo?",
  "CONFIRM_DELETE_SERVICE": "Eliminare servizio directory?\nGli utenti importati dal servizio verranno mantenuti. Le password verranno riportate ai valori  impostati in precedenza in Portfolio oppure verranno disabilitate se non sono state definite in precedenza.",
  "CONFIRM_TRUNCATE_VALUES": "La lunghezza max supera uno o più valori di default o predefiniti per questo campo. Troncare i valori?",
  "CONNECTION_REFUSED_ERROR": "Collegamento al servizio directory rifiutato. Controllare nome host e impostazioni porta.",
  "CONTAINS": "contiene",
  "CONTINUE": "Continua",
  "CREATE": "Crea",
  "CREATE_A_CERTIFICATE_REQUEST": "Crea una richiesta di firma del certificato",
  "createContactSheet": "Crea PDF",
  "CREATED_BY": "Creato da",
  "CREATE_MAPPING": "Crea Mappatura",
  "CREATE_USER_EXCLUSION_MAPPING": "Escludi Utente",
  "CREATED_ON_DATE": "Data di creazione",
  "DATE_FORMAT": "DD/MM/YYYY",
  "DATE_FORMAT_ERROR": "Errore di configurazione; formattazione stringa non corretta.",
  "DATE_INVALID_CHAR_ERROR": "La data contiene caratteri non validi.",
  "DATE_TIME_FORMAT": "DD/MM/YYYY L:NN A",
  "DATE_TIME_SECONDS_FORMAT": "DD/MM/YYYY L:NN:SS A",
  "DATE_WRONG_DAY_ERROR": "Immettere un giorno valido per il mese.",
  "DATE_WRONG_LENGTH_ERROR": "Digitare la data nel formato:",
  "DATE_WRONG_MONTH_ERROR": "Inserire un mese tra 1 e 12",
  "DATE_WRONG_YEAR_ERROR": "Inserire un anno tra 0 e 9999",
  "DEFAULT_ACCESS_LEVEL": "Ruolo predefinito",
  "DEFAULT_CATALOG": "Catalogo predefinito",
  "DEFAULT_CATALOG_NONE": "Nessuno",
  "DEFAULT_PORT_NON_SSL": "Porta predefinita per non-SSL:",
  "DEFAULT_PORT_SSL": "Porta predefinita per SSL:",
  "DELETE": "Elimina",
  "DELETE_SOURCE": "Elimina Sorgente",
  "DELETE_ALL_NESTED_VALUES_CONFIRMATION": "Cancellare tutti i valori? Ciò cancellerà tutti i valori inclusi i valori nidificati.",
  "DELETE_MULTIPLE_NESTED_VALUES_CONFIRMATION": "Eliminare il valore '{value}'?\nContiene valori nidificati che saranno cancellati.",
  "DELETE_NESTED_VALUE_CONFIRMATION": "Cancellare i valori selezionati? Contengono valori nidificati che saranno altresì cancellati.",
  "DELETE_WARNING_BOX_MSG": "Avvertenza! Non sarà possibile annullare l'eliminazione!",
  "DELETE_WARNING_CATALOG_VAULT": "Tutti gli archivi nel catalogo si distruggeranno.",
  "DIAGNOSTIC_DATA_TITLE": "Invia Report diagnostico a Portfolio DAM",
  "DIAGNOSTIC_DATA_ACCOUNT_NAME": "Società o Nome Account (Obbligatorio)",
  "DIAGNOSTIC_DATA_CONTACT_NAME": "Nome contatto",
  "DIAGNOSTIC_DATA_TS_TICKET_NUMBER": "Numero ticket assistenza tecnica",
  "DIAGNOSTIC_DATA_SEND_REPORT_BUTTON": "Invia report",
  "DIAGNOSTIC_STATUS_ERROR": "Si è verificato un problema durante il caricamento del report diagnostico {date}",
  "DIAGNOSTIC_STATUS_SENDING": "Invio in corso...",
  "DIAGNOSTIC_STATUS_SUCCESS": "Report diagnostico inviato con successo a Portfolio DAM il {date}",
  "DIRECTORY_SERVICE_CONNECT_ERROR": "Impossibile collegarsi al servizio directory. Controllare nome host e impostazioni porta.",
  "DIRECTORY_SERVICES": "Servizi Directory",
  "DIRECTORY_USERS_CANNOT_BE_DELETED": "Gli utenti di Servizi Directory non possono essere eliminati!",
  "DISTRIBUTION_GROUPS": "Gruppi di distribuzione",
  "DOWNLOAD_CERT_PROMPT": "Scaricare il file di richiesta del certificato?",
  "DOWNLOAD_COMPLETE_STRING": "Download completato.",
  "downloadPreviews": "Scarica anteprime",
  "EMAIL_ADDRESS": "Indirizzo e-mail",
  "EMAIL_CONFIG_AUTH_PASSWORD": "Password",
  "EMAIL_CONFIG_AUTH_USERNAME": "Nome utente",
  "EMAIL_CONFIG_ENABLED": "Abilita notifiche via e-mail",
  "EMAIL_CONFIG_FROM_ADDRESS": "E-mail da indirizzo",
  "EMAIL_CONFIG_INVALID_GENERIC": "Configurazione Server E-mail non valida",
  "EMAIL_CONFIG_INVALID_SERVER_NOT_FOUND": "Server e-mail non trovato",
  "EMAIL_CONFIG_INVALID_AUTHENTICATION_FAILED": "Autenticazione Server E-mail non riuscita",
  "EMAIL_CONFIG_MESSAGE": "Ogni utente che desidera ricevere notifiche deve avare un indirizzo e-mail assegnato nel pannello Utenti.",
  "EMAIL_CONFIG_SERVER_ADDRESS": "Indirizzo Server SMTP",
  "EMAIL_CONFIG_SERVER_PORT": "Porta Server SMTP",
  "EMAIL_CONFIG_SUCCESS_MESSAGE": "Server SMTP validato",
  "EMAIL_CONFIG_USE_SSL_TLS": "Utilizzare SSL / TLS",
  "EMAIL_CONFIG_USE_SMTP_AUTH": "Utilizzare autenticazione SMTP",
  "EMAIL_CONFIG_VALIDATE": "Connessione di prova",
  "EMAIL_CONFIG_VALIDATED": "Server e-mail validato",
  "english": "Inglese",
  "ENTIRE_TREE_UNDER_SEARCH_BASE": "Intera struttura sotto Ricerca Base",
  "EQUALS": "uguale",
  "EXPORT_MENU_STRING": "Esporta valori",
  "FADEL_HOWTO": "Collegamento al vostro cliente di FADEL:",
  "FALSE_LABEL": "Falso",
  "FAULT_MSG_ADMIN_SERVICE_CREATION_ERROR": "Verificare che il server di amministrazione sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare questa applicazione.",
  "FAULT_MSG_BACKUP_RESTORE_IN_PROGRESS": "Questa operazione non può essere eseguita mentre è in corso il backup o il ripristino.",
  "FAULT_MSG_CATALOG_IS_IN_ADMIN_MODE": "Operazione non riuscita poiché il catalogo è in modalità amministrazione.",
  "FAULT_MSG_CREATE_CATALOG_DUPLICATE_NAME": "Esiste già un catalogo con questo nome.",
  "FAULT_MSG_CREATE_USER_DUPLICATE_ACCOUNT_NAME": "Esiste già un utente con questo nome account.",
  "FAULT_MSG_DB_IN_USE": "Impossibile completare l'operazione perché il catalogo è attualmente in uso da parte di un amministratore.",
  "FAULT_MSG_DELETE_ADMIN": "Impossibile eliminare l'account dell'amministratore.",
  "FAULT_MSG_DELETE_SELF": "Impossibile eliminare l'account utente.",
  "FAULT_MSG_DELETE_CATALOG_TEMPLATE_ERROR": "Si è verificato un errore imprevisto durante la cancellazione del modello di catalogo",
  "FAULT_MSG_DUPE_NAME": "Esiste già un oggetto con questo nome. Utilizzare un altro nome.",
  "FAULT_MSG_DUPLICATE_MEDIA_ENGINE_ADDRESS": "Esiste già un Media Engine con questo indirizzo e questa porta.",
  "FAULT_MSG_ENTITY_VERSION_MISMATCH": " Operazione non riuscita poiché le informazioni client erano scadute.",
  "FAULT_MSG_IDENT_SERVICE_CREATION_ERROR": "Verificare che il server sia in funzione nella macchina locale sulla porta indicata nella relativa pagina. Diversamente, riavviare il server e ricaricare l'applicazione.",
  "FAULT_MSG_INVALID_SESSION_ID": "Sessione scaduta. È necessario accedere di nuovo al server.",
  "FAULT_MSG_IS_NOT_LICENSED": "Server non licenziato per tale operazione.",
  "FAULT_MSG_LEGACY_21000": "Operazione non riuscita a causa di un errore interno sconosciuto.",
  "FAULT_MSG_LOGGING_ERR_UPDATE": "Si è verificato un errore nell'aggiornamento della configurazione di log",
  "FAULT_MSG_LOG_DIR_NOT_VALID": "Le directory di log specificata non esiste, non è scrivibile oppure il percorso specificato non è una directory.",
  "FAULT_MSG_NO_DIRECTORY": "La posizione specificata non esiste o non è una directory.",
  "FAULT_MSG_NULL_DESCRIPTION": "Si è verificato un errore imprevisto, ma non esiste alcuna descrizione per il report.",
  "FAULT_MSG_NULL_FAULTEVENT": "Si è verificato un errore imprevisto, ma non esiste alcun dettaglio per il report.",
  "FAULT_MSG_OPERATION_INSUFFICIENT_PRIVILEGES": "Operazione non riuscita poiché non si dispone dei privilegi sufficienti.",
  "FAULT_MSG_OPERATION_IS_INVALID": "Operazione non valida.",
  "FAULT_MSG_RENAME_CATALOG_TEMPLATE_ERROR": "Si è verificato un errore imprevisto durante la ridenominazione del modello di catalogo",
  "FAULT_MSG_SAVE_CATALOG_TEMPLATE_ERROR": "Si è verificato un errore imprevisto durante il salvataggio del modello di catalogo",
  "FAULT_MSG_SERVER_NOT_RUNNING": "Server non in funzione.",
  "FAULT_MSG_ENTERPRISE_NOT_LICENSED": "Operazione non riuscita poiché il server non ha una licenza Enterprise Module.",
  "FAULT_MSG_REMOVE_METADATA_DEF": "Rimozione definizione metadata non riuscita. Può essere in uso da altri cataloghi.",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT": "Il server ha restituito un errore con questo messaggio: ",
  "FAULT_MSG_UNHANDLED_PORTFOLIO_FAULT_WITHOUT_MESSAGE": "Il server ha restituito un errore senza messaggi di errore: ",
  "FAULT_MSG_UNHANDLED_UNKNOWN_FAULT": "Il server ha restituito un errore di tipo sconosciuto con il seguente messaggio:",
  "FAULT_MSG_UNKNOWN_SMTP_SERVER": "Impossibile collegarsi al server di posta specificato.",
  "FAULT_MSG_WINDOWS_SERVICE_IS_NOT_RUNNING": "Operazione non riuscita poiché un servizio non era nello stato previsto.",
  "FAULT_MSG_INVALID_LOGINID_OR_PASSWORD": "Il nome utente o la password indicati per il database non sono validi.",
  "FAULT_MSG_BAD_DB_PORT": "La porta del database specificata non è valida.",
  "FAULT_MSG_BAD_DB_HOST": "Il nome host del database o la porta specificata non sono validi.",
  "FIELD_ACTION_ADD": "Aggiungi nuovo campo personalizzato",
  "FIELD_ACTION_DELETE": "Elimina campo selezionato",
  "FIELD_ACTION_MANAGE_CUSTOM_XMP_NAMESPACES": "Spazio nomi XMP",
  "FIELD_ACTION_MANAGE_METADATA": "Gestisci metadata",
  "FIELD_CATEGORY_CUSTOM": "Campi personalizzati",
  "FIELD_CATEGORY_SYSTEM": "Campi sistema",
  "FIELD_CATEGORY_EXIF": "EXIF",
  "FIELD_CATEGORY_IPTC": "IPTC",
  "FIELD_CATEGORY_XMP": "XMP",
  "FIELD_CATEGORY_MOVIE": "Filmato",
  "FIELD_CATEGORY_OFFICE": "MS Office",
  "FIELD_CATEGORY_GEO": "GEO",
  "FIELD_CATEGORY_LABEL": "Categoria campo",
  "FIELD_DISABLE_CONFIRM_MSG": "Vuoi disabilitare il campo selezionato?",
  "FIELD_ENABLE_ALL_CATEGORIES_LABEL": "Abilita tutto",
  "FIELD_FORM_LABEL_ADD_EXTRACT_MAPPING": "Aggiungi Estrai mappatura",
  "FIELD_FORM_LABEL_DEFAULT_VALUE": "Valore predefinito",
  "FIELD_FORM_LABEL_DISABLED": "(Disabilitato)",
  "FIELD_FORM_LABEL_EMBED": "Nascondi metadata",
  "FIELD_FORM_LABEL_EXTRACT": "Estrai da metadata",
  "FIELD_FORM_LABEL_FIELD_NAME": "Nome campo",
  "FIELD_FORM_LABEL_FIELD_TYPE": "Tipo campo",
  "FIELD_FORM_LABEL_HAS_MULTIPLE_VALUES": "Consenti più valori",
  "FIELD_FORM_LABEL_HAS_PREDEFINED_VALUES": "Ha valori predefiniti",
  "FIELD_FORM_LABEL_HELP_TEXT": "Testo guida",
  "FIELD_FORM_LABEL_MAX": "Max: {max}",
  "FIELD_FORM_LABEL_MAX_LENGTH": "Lunghezza max",
  "FIELD_FORM_LABEL_METADATA_TAG": "Nome metadati",
  "FIELD_FORM_LABEL_METADATA_TYPE": "Tipo metadati",
  "FIELD_FORM_LABEL_ONLY_PREDEFINED_VALUES": "Consenti solo valori predefiniti",
  "FIELD_FORM_LABEL_PRECISION": "Precisione",
  "FIELD_FORM_LABEL_PREDEFINED_VALUES": "Valori predefiniti",
  "FIELD_FORM_LABEL_SHOW_TIME": "Mostra ora",
  "FIELD_FORM_LABEL_USE_METADATA": "Estrarre e incorporare metadati",
  "FIELD_FORM_WARNING_DUPE_EMBEDS": "Avviso: Più di un campo si incorpora su '{metadata}'",
  "FIELD_METADATA_DATA_TYPE_LABEL": "Tipo dati",
  "FIELD_METADATA_DEFINITION_IS_CUSTOM": "È personalizzato",
  "FIELD_METADATA_DEFINITIONS_TITLE": "Definizioni metadati",
  "FIELD_METADATA_DELETE_CONFIRM_MSG": "Conferma: Eliminare la definizione dei metadati?",
  "FIELD_METADATA_MULTIVALUED_TYPE_LABEL": "Tipo multivalore",
  "FIELD_METADATA_MULTIVALUED_TYPE_NOT_MULTIVALUED_LABEL": "Non multivalore",
  "FIELD_METADATA_MULTIVALUED_TYPE_ORDERED_LABEL": "Ordinato",
  "FIELD_METADATA_MULTIVALUED_TYPE_UNORDERED_LABEL": "Non ordinato",
  "FIELD_METADATA_NAME_LABEL": "Nome",
  "FIELD_METADATA_NAMESPACE_LABEL": "Spazio dei nomi",
  "FIELD_METADATA_NEW_NAMESPACE_TOOLTIP": "Aggiungi spazio dei nomi XMP personalizzato...",
  "FIELD_METADATA_TAG_LABEL": "Tag",
  "FIELD_METADATA_TYPE_LABEL": "Tipo",
  "FIELD_MULTIPLE_FIELDS_SELECTED_MESSAGE": "Più campi selezionati",
  "FIELD_NAMESPACE_ABBREVIATION": "Abbreviazione",
  "FIELD_NAMESPACE_REMOVE_CONFIRMATION": "Eliminare spazio dei nomi XMP personalizzato?\nUsando lo spazio dei nomi è possibile vi siano delle definizioni di campo.",
  "FIELD_NAMESPACE_URI": "Spazio dei nomi URI",
  "FIELD_NEW_FIELD_NAME": "Nuovo campo",
  "FIELD_NEW_METADATA_TITLE": "Nuova definizione metadati",
  "FIELD_NEW_NAMESPACE_TITLE": "Nuovo spazio dei nomi XMP personalizzato",
  "FIELD_NO_FIELD_SELECTED_MESSAGE": "Nessun campo selezionato",
  "FIELD_PAGE_TITLE": "Gestisci campi per catalogo '{catalogName}'",
  "FIELD_REVERT_CONFIRM_MSG": "Conferma: Ripristinare il campo?",
  "FIELD_TYPE_BLOB": "Blob",
  "FIELD_TYPE_BOOLEAN": "Booleano",
  "FIELD_TYPE_DATETIME": "Data/ora",
  "FIELD_TYPE_DECIMAL": "Decimale",
  "FIELD_TYPE_LANG_ALT": "Alt Lang",
  "FIELD_TYPE_NUMBER": "Numero",
  "FIELD_TYPE_PICTURE": "Immagine",
  "FIELD_TYPE_STRING": "Stringa",
  "FIELD_TYPE_STRUCTURE": "Struttura",
  "FIELD_TYPE_TEXTBLOCK": "Blocco testo",
  "FIELD_TYPE_UNKNOWN": "Sconosciuto",
  "FIELD_TYPE_URL": "URL",
  "FILE_IO_ERROR_MSG": "C'è stato un errore caricando il documento sul server.",
  "FILE_WRONG_TYPE_ERROR_MSG": "Questo formato di documento non è supportato. \n Scegli un documento di formato jpeg, gif o png.",
  "FOLDER_PATH_AUTOSYNC_FILES_STRING": "File",
  "FOLDER_PATH_ALREADY_EXIST_AS_FILE": "Esiste un file con questo nome.",
  "FOLDER_PATH_DOES_NOT_EXIST": "Il percorso non esiste.",
  "FOLDER_PATH_ERROR": "Errore",
  "FOLDER_PATH_NOT_VERIFIED": "Il percorso alla cartella non è stato verificato.",
  "FOLDER_PATH_PATH": "Percorso",
  "FOLDER_PATH_OPERATION_INVALID": "Operazione non valida",
  "FOLDER_PATH_SUCCESS": "Riuscito",
  "FOLDER_PATH_TYPE_AUTOSYNC": "autosync",
  "FOLDER_PATH_TYPE_PREVIEW": "anteprima",
  "FOLDER_PATH_UNKNOWN_FAULT": "Errore sconosciuto",
  "french": "Francese",
  "FULL_NAME": "Nome intero",
  "FULLY_QUALIFIED_DOMAIN_NAME": "Nome dominio completamente qualificato",
  "german": "Tedesco",
  "GLOBAL_SETTINGS_AUTOSYNC_PATH_LABEL": "Creare cartelle AutoSync per i nuovi cataloghi in questa cartella",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR": "Colore di sottofondo",
  "GLOBAL_SETTINGS_BACKGROUND_COLOR_TOOLTIP": "Colore di sottofondo dello schermo log-in.",
  "GLOBAL_SETTINGS_CATALOG_DEFAULTS": "Impostazioni predefinite catalogo",
  "GLOBAL_SETTINGS_CHOOSE_FILE": "Scegli un documento",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE": "Immagine personalizzato",
  "GLOBAL_SETTINGS_CUSTOM_IMAGE_INFO_TEXT": "La grandezza indicativa dovrebbe stare dentro 2400 x 1350 pixel.",
  "GLOBAL_SETTINGS_CUSTOM_TITLE": "Titolo personalizzato",
  "GLOBAL_SETTINGS_CUSTOM_TITLE_TOOLTIP": "Il titolo che appare nel browser o nel segnalibri.",
  "GLOBAL_SETTINGS_CUSTOMIZED_LOGIN_SCREEN": "Schermo di log-in personalizzato",
  "GLOBAL_SETTINGS_DEFAULT_ACCESS_LABEL": "Ruolo predefinito",
  "GLOBAL_SETTINGS_DEFAULT_LOGIN_SCREEN": "Schermo di log-in predefinito",
  "GLOBAL_SETTINGS_EMAIL_CONFIGURATION": "Notifiche via e-mail",
  "GLOBAL_SETTINGS_FADEL": "FADEL Rights Cloud",
  "GLOBAL_SETTINGS_FOLDERS_ACCESSIBLE_INFO_MSG": "La posizione delle cartelle AutoSync e Anteprima deve essere accessibile al server.",
  "GLOBAL_SETTINGS_IMAGE_URL": "Collegamento",
  "GLOBAL_SETTINGS_IMAGE_URL_TOOLTIP": "Cliccando sull'immagine apre questo URL in una nuova finestra.",
  "GLOBAL_SETTINGS_NOT_LOGGED_IN_INFO_MSG": "Per apportare delle modifiche, avviare il server o verificare se la licenza server è scaduta.",
  "GLOBAL_SETTINGS_PREVIEW_PATH_LABEL": "Salvare le anteprime dei nuovi cataloghi in questa cartella",
  "GLOBAL_SETTINGS_SERVER_DATA_LOCATIONS": "Posizioni dati server",
  "GLOBAL_SETTINGS_WEB_CLIENT_CUSTOMIZATION": "Adattamento di collegamento Portfolio",
  "GLOBAL_SETTINGS_SSO_CREDENTIALS": "Credenziali accesso singolo",
  "GLOBAL_SETTINGS_USER_ACCOUNT_TOOLTIP": "Inserire l'account utente associato al servizio Portfolio Server per autenticazione Kerberos.",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_LABEL": "Cartella di lavoro temporanea: ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_CHANGED_MSG": "La cartella di lavoro verrà modificata al prossimo riavvio del server. La nuova cartella verrà posizionata in: ",
  "GLOBAL_SETTINGS_WORK_DIRECTORY_REQUIRES_RESTART_MSG": "Affinché questa modifica abbia effetto è necessario riavviare il server.",
  "GLOBAL_SETTINGS_VAULT_CONFIGURATION": "Configurazione Portfolio Vault:",
  "GLOBAL_SETTINGS_VAULT_DIRECTORY_LABEL": "Cartella insieme di credenziali Portfolio:",
  "SERVER_DATA_DEFAULT_VAULT_LOCATION_IS": "Posizione predefinita insieme di credenziali Portfolio:",
  "GLOBAL_SETTINGS_VAULT_SERVER_RUNNING_MESSAGE": "Per spostare Portfolio Vault, spegnere prima il server.",
  "HELP_URL": "https://helpdocs.portfoliodam.com/it/portfolio/administration/{version}/index.htm",
  "HELP_URL_FADEL": "https://helpdocs.portfoliodam.com/portfolio/{version}/administration/it/Content/03_Catalogs/05_FADEL.htm",
  "HOSTNAME": "Nome host",
  "IDENTITY_SERVICE_DEFAULT_ROLE_STRING": "(predefinito)",
  "IDENTITY_SERVICE_SUCCESSFUL_CREATION": "Connessione al servizio directory avvenuta con successo. Configurazione salvata.",
  "IMAGE_FILE_FILTER": "Immagini (jpg, gif, png)",
  "IMPORT_LDAP": "Importa utenti da server LDAP/AD",
  "IMPORT_LDAP_SPECIFY_SERVER": "Especificar servidor LDAP/AD",
  "IMPORT_MENU_STRING": "Importa valori",
  "IMPORT_SOURCE": "Importa sorgente",
  "INVALID_DN_SYNTAX_ERROR": "Impossibile collegarsi al servizio directory a causa di un errore di sintassi DN non valido. Controllare il nome utente.",
  "japanese": "Giapponese",
  "LAST_CERTIFICATE_REQUEST_LABEL": "Ultima richiesta di certificato",
  "LAST_MODIFIED_BY": "Ultima modifica di",
  "LAST_MODIFIED_DATE": "Data ultima modifica",
  "LDAP_ADDRESS": "Indirizzo server LDAP/AD",
  "LDAP_BIND_USERNAME": "Nome utente LDAP Bind",
  "LDAP_SYNC_NOTIFICATION": "Il server ha ricevuto una richiesta di sincronizzazione.",
  "LIC_ADD_MESSAGE": "Copiare e incollare le licenze o inserirle singolarmente una per riga.",
  "LIC_ADD_SN": "Aggiungi nuova licenza",
  "LIC_ADD_SN_SHORT": "Aggiungi licenze",
  "LIC_ASSET_CAP_DISPLAY": "Asset",
  "LIC_DAYS_REMAINING": "({days} giorni restanti)",
  "LIC_DEMO_PERIOD": "Periodo di demo",
  "LIC_ERROR_MSG": "Numero di serie non valido; riprovare. Se il problema persiste, controllare il log del server e contattare l'amministratore.",
  "LIC_NOT_COMPATIBLE_WITH_LITE_ERROR_MSG": "Il numero di serie non può essere aggiunto a Portfolio Studio.",
  "LITE_CANNOT_CREATE_FDB_CATALOG": "La licenza Portfolio non consente più di un catalogo. Aggiornare la licenza Portfolio per eseguire questa azione.",
  "LITE_CANNOT_SERVE_FDB_CATALOG": "La licenza Portfolio Server di cui si dispone non consente di prendere ulteriori cataloghi online.",
  "LITE_THIS_FEATURE_NOT_SUPPORTED": "La licenza Portfolio Server non supporta questa azione.",
  "LOGGING_CONFIGURATION": "Configurazione di log",
  "LOGGING_CONFIGURATION_SERVER_RUNNING_MESSAGE": "Per cambiare la posizione del log, spegnere prima il server del Portfolio.",
  "LOGGING_DEFAULT_LOCATION_MSG": "La posizione predefinita per il log è",
  "LOGGING_DIR_MUST_EXIST": "NOTA: Per poter modificare correttamente la directory di log, la directory da specificare deve essere già esistente ed essere scrivibile da parte dell'utente per il quale è in funzione Portfolio Server.",
  "LOGGING_LOG_DIR": "Directory di log:",
  "LOGGING_LOG_LEVEL": "Livello di log",
  "LOGGING_NUM_LOGS_TO_RETAIN": "Numero di log da conservare",
  "LOGIN": "Login",
  "MAPPING_HEADER": "Mappatura utente/gruppo a Portfolio",
  "MAPPINGS_HAVE_BEEN_MODIFIED_ALERT": "Le mappature sono state modificate, salvarle?",
  "MEDIA_ENGINES_ACTION_ADD": "Aggiungi nuovo Media Engine",
  "MEDIA_ENGINES_ACTION_DELETE": "Elimina Media Engine",
  "MEDIA_ENGINES_ACTION_EDIT": "Visualizza/Modifica dettagli Media Engine",
  "MEDIA_ENGINES_CANT_ACTIVATE_NO_LICENSE": "Impossibile aggiungere un altro Media Engine attivo poiché il server sta già usando il numero massimo di media engine attivi consentito dalla licenza Portfolio Media Engine.",
  "MEDIA_ENGINES_CANT_ADD_NO_LICENSES": "Impossibile aggiungere un Media Engine poiché il server non dispone di una licenza Portfolio Media Engine disponibile.",
  "MEDIA_ENGINES_CANT_REMOVE_BUILT_IN_SERVER": "Impossibile rimuovere il Media Engine incorporato.",
  "MEDIA_ENGINES_COLUMN_ACTIVE": "Attivo",
  "MEDIA_ENGINES_COLUMN_ADDRESS": "Indirizzo",
  "MEDIA_ENGINES_COLUMN_PORT": "Porta",
  "MEDIA_ENGINES_CONFIRM_DELETE": "Eliminare il Media Engine selezionato?",
  "MEDIA_ENGINES_EDIT_DETAILS_HEADER": "Dettagli Media Engine",
  "MEDIA_ENGINES_LICENSES_LABEL": "Posti Media Engine disponibili per l'attivazione",
  "MEDIA_ENGINES_NEW_DETAILS_HEADER": "Dettagli nuovo Media Engine",
  "MEDIA_ENGINES_WARN_NO_ENGINES_ARE_ACTIVE": "Nessun Media Engine attivo. È necessario attivare un Media Engine prima che i client debbano utilizzare i servizi Portfolio Media.",
  "MOBILE": "Cellulare",
  "MOBILE_ENABLED": "Abilita caricamenti dal cellulare",
  "MOBILE_FOLDER_VERBIAGE": "Salva i caricamenti dal cellulare in questa cartella:",
  "MOBILE_CREATE_CATALOG_VERBIAGE": "Creare il nuovo catalogo 'caricamenti da cellulare' per visionare automaticamente questa cartella (raccomandato)",
  "MOBILE_CATALOG_NAME": "Caricamenti da cellulare",
  "modifyAssetContents": "Verifichi i beni",
  "MODIFY_LDAP": "Modifica richiesta LDAP",
  "NAME": "Nome",
  "NAME_TOO_LONG_ERROR": "Il nome deve contenere meno di 256 caratteri",
  "NAV_ABOUT": "Info su",
  "NAV_ACCESS_LEVELS": "Ruoli",
  "NAV_AUTOSYNC": "Sincr. automatica",
  "NAV_BACKUPS": "Backup/Ripristino",
  "NAV_CATALOGS": "Cataloghi",
  "NAV_GLOBAL_SETTINGS": "Impostazioni globali",
  "NAV_HELP": "Guida",
  "NAV_LICENSES": "Licenze",
  "NAV_LOGOUT": "Logout",
  "NAV_MEDIA_ENGINES": "Media Engine",
  "NAV_NETPUBLISH_SETTINGS": "NetPublish",
  "NAV_PORTS": "Porte",
  "NAV_REPORTING": "Creazione di report",
  "NAV_SETTINGS": "Impostazioni",
  "NAV_STATUS": "Stato",
  "NAV_USERS": "Utenti",
  "NO_CATALOGS": "Nessuno",
  "NO_FILE_SELECTED": "Nessun documento scelto",
  "VaultFolderNotFound": "La cartella Portfolio Vault non è stata trovata in {path}.",
  "NO_VAULT_FOLDER": "La cartella Portfolio Vault non è stata trovata in {path}.  Verificare la posizione della cartella nel proprio file di sistema, e nella pagina Impostazioni globali -> Dati server di questa applicazione.",
  "NOTES": "Note",
  "NUMBER_DECIMAL_POINT_COUNT_ERROR": "Il separatore decimale può essere presente solo una volta.",
  "NUMBER_EXCEEDS_MAX_ERROR": "Il numero immesso è troppo grande.",
  "NUMBER_INTEGER_ERROR": "Il numero deve essere un numero intero.",
  "NUMBER_INVALID_CHAR_ERROR": "L'immissione contiene caratteri non validi.",
  "NUMBER_INVALID_FORMAT_CHARS_ERROR": "Uno dei parametri di formattazione non è valido.",
  "NUMBER_LOWER_THAN_MIN_ERROR": "L'importo inserito è troppo piccolo.",
  "NUMBER_NEGATIVE_ERROR": "L'importo può essere negativo.",
  "NUMBER_PRECISION_ERROR": "L'importo inserito è composto da troppe cifre dopo il punto decimale.",
  "NUMBER_SEPARATION_ERROR": "Il separatore delle migliaia deve essere seguito da tre cifre.",
  "OK": "OK",
  "ON_DATE": "il",
  "OPEN_DIRECTORY": "Open Directory",
  "OPEN_DIRECTORY_GROUPS": "Gruppi",
  "ORGANIZATION_NAME": "Nome organizzazione",
  "ORGANIZATIONAL_UNIT": "Unità organizzazione",
  "PASSWORD": "Password",
  "PASSWORD_CONFIRM": "Conferma password",
  "PASSWORD_TOO_LONG_ERROR": "La password deve contenere meno di 256 caratteri",
  "PORT": "Porta",
  "PORT_VALUE_TOO_HIGH_ERROR": "Il valore di porta deve essere inferiore a 65536.",
  "PortfolioAssetCap": "Portfolio Asset Cap",
  "PortfolioAPI": "Portfolio API",
  "PortfolioDemo": "Demo",
  "PortfolioDirServices": "Portfolio Directory Services",
  "PortfolioServer": "Portfolio Server",
  "PortfolioStudio": "Portfolio Studio Edition",
  "PortfolioProfessional": "Portfolio Professional Edition",
  "PortfolioEnterprise": "Portfolio Enterprise Edition",
  "PortfolioMediaEngine": "Portfolio Media Engine",
  "NetPublish": "Portfolio NetPublish",
  "PortfolioMobile": "Portfolio Flow",
  "PortfolioSmartKeywords": "Portfolio Smart Keyword",
  "PortfolioUserConnection": "Portfolio User Connection",
  "PortfolioSingleSignOn": "Accesso singolo (SSO)",
  "PORT_CURRENT_VALUE": "Valore corrente",
  "PORT_ERROR_MSG_BAD_PORT_VALUE": "Il nuovo valore porta deve essere un numero compreso tra 1 e 65535.",
  "PORT_ERROR_MSG_CONFLICT": "Impossibile aggiornare i valori porta poiché uno o più dei nuovi valori porta è già in uso sul server.",
  "PORT_FIND_PORT": "Trova porta",
  "PORT_NAME": "Nome",
  "PORT_NEW_VALUE": "Nuovo valore",
  "PORT_RESTART_NOTICE": "Nota: gli aggiornamenti delle porte hanno effetto solo dopo il riavvio del server.",
  "PORT_RESTART_SERVER": "Riavvia server",
  "PORT_UPDATE_PORTS": "Aggiorna porte",
  "PORT_WARNING_ADMIN_RESTART": "Porta di amministrazione modificata. Il browser sarà reindirizzato nella nuova posizione fra {numSecs} secondi.",
  "PREVIEW_MAX_VIDEO_RESOLUTION_360": "360p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_480": "480p",
  "PREVIEW_MAX_VIDEO_RESOLUTION_540": "540p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_720": "720p HD",
  "PREVIEW_MAX_VIDEO_RESOLUTION_1080": "1080p HD",
  "PROMPT_ARE_YOU_SURE": "Sicuro?",
  "PROMPT_COULD_NOT_CREATE_FOLDER": "Impossibile creare cartella. Inserire un altro percorso.",
  "PROMPT_COULD_NOT_CREATE_FOLDERS": "Inserire un altro percorso alla cartella poiché non è possibile creare i seguenti percorsi:",
  "PROMPT_COULD_NOT_CREATE_FOLDER_FILE_CONFLICT": "Impossibile creare cartella poiché esiste già un file con questo nome. Inserire un altro percorso.",
  "PROMPT_CREATE_THAT_FOLDER": "Questa cartella non esiste. Crearla?",
  "PROMPT_CREATE_THESE_FOLDERS": "Queste cartelle non esistono. Si desidera crearle?",
  "PROMPT_DELETE_LICENSE_CONFIRM": "Eliminare la licenza selezionata?",
  "QUERY": "Interrogazione",
  "REMOVE": "Rimuovi",
  "REMOVE_DIRECTORY_SERVICE": "Rimuovi servizio directory",
  "REPLACE_USER_MAPPING_CONFIRMATION": "Per questo utente esiste già una mappatura utente regolare. Sostituirla con una mappatura utente di esclusione?",
  "REPLACE_USER_EXCLUSION_CONFIRMATION": "Per questo utente esiste già una mappatura utente di esclusione. Sostituirla con una mappatura utente regolare?",
  "REQUIRED_FIELD_ERROR": "Questo campo è obbligatorio",
  "REVERT": "Inverti",
  "REVERT_CHANGES": "Inverti Modifiche",
  "ROLE_FOR_IMPORT": "Ruolo per importazione",
  "ROLES_PERMISSION_ENABLED_HEADER": "Abilitato",
  "ROLES_PERMISSION_NAME_HEADER": "Operazione",
  "SAVE": "Salva",
  "SAVE_MAPPING": "Salva Mappatura",
  "saveOutputSetting": "Gestisci preimpostazioni conversione e fate il PDF",
  "SEARCH": "Cerca",
  "SEARCH_BASE": "Base di Ricerca",
  "SEARCH_RESULTS": "Risultati ricerca",
  "SECURITY_GROUPS": "Gruppi di sicurezza",
  "SELECT": "Seleziona",
  "SEND_DIAGNOSTIC_DATA": "Invia Report diagnostico a Portfolio DAM",
  "SERVER_DATA_DEFAULT_WORK_LOCATION_IS": "Posizione di lavoro predefinita: ",
  "SERVER_RESTART_REQUIRED": "È necessario riavviare il server affinché le modifiche abbiano effetto.",
  "SERVER_STATE_ERROR": "Errore: Vedere il log di amministrazione per ulteriori dettagli",
  "SERVER_STATE_STARTED": "Esecuzione",
  "SERVER_STATE_STARTING": "Avvio",
  "SERVER_STATE_STOPPED": "Interrotto",
  "SERVER_STATE_STOPPING": "Interruzione",
  "SERVER_STATE_UNKNOWN": "Sconosciuto",
  "SERVICE_BROWSER": "Browser servizi",
  "SK_ENGINE_APPAREL": "Abito",
  "SK_ENGINE_CELEBRITIES": "Celebrità",
  "SK_ENGINE_FOOD": "Cibo",
  "SK_ENGINE_GENERAL": "Generale",
  "SK_ENGINE_LOGO": "Logo",
  "SK_ENGINE_MODERATION": "Regolazione",
  "SK_ENGINE_NSFW": "NSFW",
  "SK_ENGINE_TRAVEL": "Viaggio",
  "SK_ENGINE_WEDDINGS": "Matrimoni",
  "SSL_HANDSHAKE_ERROR": "Handshake SSL non riuscito; verificare che la porta e le impostazioni SSL siano corrette.",
  "STARTS_WITH": "inizia con",
  "STATE_OR_PROVINCE": "Stato o Provincia",
  "STATUS": "Stato",
  "STATUS_ADMIN_LOG": "Log di ammin.",
  "STATUS_API_VERSION_LABEL": "API",
  "STATUS_API_STATE_LICENSED": "Licenziato",
  "STATUS_API_STATE_UNLICENSED": "Non licenziato",
  "STATUS_CLEAR_ADMIN_LOG": "Cancella log di ammin.",
  "STATUS_CONNECTED_USERS": "Utenti connessi",
  "STATUS_MAX_ALLOWED_CONNECTIONS": "Connessioni massime",
  "STATUS_MEDIA_ENGINE_VERSION_LABEL": "Media Engine",
  "STATUS_MEDIA_ENGINES_ACTIVE": "Attivo",
  "STATUS_MEDIA_ENGINES_LABEL": "Media Engine",
  "STATUS_RESTART_SERVER": "Riavvia Portfolio",
  "STATUS_SEAT_USAGE": "Utilizzo posto",
  "STATUS_SERVER_STATE": "Portfolio State",
  "STATUS_SERVER_VERSION_LABEL": "Portfolio",
  "STATUS_START_SERVER": "Avvia Portfolio",
  "STATUS_STOP_SERVER": "Arresta Portfolio",
  "STATUS_PROBLEMS_DETECTED": "Problemi rilevati:",
  "STATUS_MSG_STARTUP_DRIVE_SPACE_UNDER_MINIMUM": "Lo spazio rimanente del disco di avvio è sotto {minSpace}GB.",
  "STATUS_MSG_WORK_FOLDER_DOES_NOT_EXIST": "La cartella di lavoro non esiste o non è accessibile.",
  "STATUS_MSG_WORK_FOLDER_NOT_WRITEABLE": "Il server Portfolio non può scrivere nella cartella di lavoro.",
  "STATUS_MSG_WORK_FOLDER_NOT_READABLE": "Il server Portfolio non può leggere dalla cartella di lavoro.",
  "STATUS_MSG_WORK_FOLDER_NOT_SYMLINKABLE": "Il server Portfolio non può creare un collegamento simbolico nella cartella di lavoro.",
  "STATUS_MSG_WORK_FOLDER_DISK_SPACE_LOW": "Lo spazio rimanente nel disco di lavoro è sotto {minSpace}GB.",
  "STATUS_MSG_WORK_FOLDER_CANT_GET_STATUS": "Impossibile ottenere lo stato della cartella di lavoro.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_STATUS_RED": "Lo stato dell’indice ElasticSearch è rosso {index}.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_UNINITIALIZED_SHARDS": "L’indice ElasticSearch {index} presenta partizioni non inizializzate.",
  "STATUS_MSG_ELASTICSEARCH_INDEX_NOT_ALL_SHARDS_ACTIVE": "Non tutte le partizioni sono attive per l’indice ElasticSearch {index}.",
  "STATUS_MSG_ELASTICSEARCH_CANT_GET_STATUS": "Impossibile recuperare lo stato ElasticSearch.",
  "STATUS_MSG_CANT_GET_ERRORS_FROM_SERVER": "Impossibile recuperare gli errori dal server Portfolio.",
  "STATUS_MSG_STARTUP_FAILED": "Avvio non riuscito",
  "STATUS_MSG_CANT_GET_SERVER_HEALTH": "Impossibile aggiornare l’integrità del server.",
  "STATUS_MSG_NATIVE_AGENT_NOT_RUNNING": "Il componente del server Native Agent non è in esecuzione.",
  "SUBJECT_ALTERNATIVE_NAMES": "Nomi alternativi oggetto",
  "SUBMIT": "Invia",
  "swedish": "Svedese",
  "SYNC_DAILY": "Sincronizza giornalmente",
  "SYNCHRONIZE_NOW": "Sincronizza ora",
  "TARGET_CATALOG": "Catalogo target",
  "THIS_LOCALE": "ir",
  "TRUE_LABEL": "Vero",
  "TOKEN": "Token",
  "TOTAL_ASSETS": "Risorse totali",
  "TWO_LETTER_COUNTRY_CODE": "Codice Paese di due lettere",
  "TYPE": "Carattere",
  "UNABLE_CONNECT_LDAP": "Impossibile collegarsi al server LDAP/AD.",
  "UNABLE_CONNECT_SERVER": "Impossibile collegarsi al server.",
  "UNKNOWN_HOST_ERROR": "Impossibile collegarsi al servizio directory a causa di una eccezione host sconosciuta. Controllare il nome host.",
  "UNKNOWN_LDAP_USER_ERROR": "In Identity Service non è stato trovato alcun utente con il nome account '{accountName}'.",
  "useCustomPresets": "Usa impostazioni di conversione predefinite",
  "USE_SSL": "Usa SSL",
  "USER_ACCOUNT": "Conteggio",
  "USER_CREATE": "Aggiungi nome utente",
  "USER_DELETE": "Elimina utenti",
  "USER_DELETE_CONFIRM": "Elimina utenti selezionati?",
  "USER_DELETE__DELETE_PRIVATE": "Eliminate in modo permanente",
  "USER_DELETE__GALLERY_PROMPT": "Il comando Rendi pubblico rende pubbliche tutte le gallerie private e a sola lettura appartenenti a questo utente. Il comando \"Elimina tutte le gallerie private\" rimuove in modo permanente le gallerie private e rende pubbliche le gallerie a sola lettura.",
  "USER_DELETE__GALLERY_PROMPT_1": "Gli articoli Pagati degli utenti saranno ripristinati e resi accessibili.",
  "USER_DELETE__GALLERY_PROMPT_2": "Le Gallerie di sola lettura degli utenti saranno rese Pubbliche.",
  "USER_DELETE__GALLERY_PROMPT_3": "Le Gallerie private degli utenti dovrebbero essere:",
  "USER_DELETE__MAKE_PUBLIC": "Rese Pubbliche",
  "USER_DETAILS": "Dettagli utente",
  "USER_IMPORT": "Importa utenti",
  "USER_IMPORT_ACCOUNT": "Nome account",
  "USER_IMPORT_ACCOUNT_ATTR": "Attributo account",
  "USER_IMPORT_EMAIL_ATTR": "Attributo e-mail",
  "USER_IMPORT_IMPORT": "Importa",
  "USER_IMPORT_IMPORT_SELECTED_USERS": "Importa utenti selezionati",
  "USER_IMPORT_MODIFY_SEARCH": "Modifica ricerca",
  "USER_IMPORT_NAME_ATTR": "Attributo nome account",
  "USER_IMPORT_NOTES_ATTR": "Attributo note",
  "USER_IMPORT_PASSWORD": "Password account",
  "USER_IMPORT_PASSWORD_ATTR": "Attributo password",
  "USER_IMPORT_SEARCH": "Cerca",
  "USER_IMPORT_SEARCH_BASE": "Base di ricerca",
  "USER_IMPORT_SEARCH_FILTER": "Filtro di ricerca",
  "USER_IMPORT_SERVER_ADDRESS": "Indirizzo server",
  "USER_IMPORT_SPECIFY_LDAP_SERVER": "Specifica server LDAP",
  "USER_LEVEL_ADMINISTRATOR": "Amministratore catalogo",
  "USER_LEVEL_EDITOR": "Curatore",
  "USER_LEVEL_NON_MEMBER": "--",
  "USER_LEVEL_PUBLISHER": "Editore",
  "USER_LEVEL_READER": "Lettore",
  "USER_MANAGE_CATALOGS": "Gestisci cataloghi per utenti selezionati",
  "USER_MULT_USERS_SELECTED": "Più utenti selezionati",
  "USER_NAME": "Nome utente",
  "USER_NEW_USER_DETAILS": "Dettagli nuovo utente",
  "USER_NEW_USER_INFO_MSG": "Per aggiungere un utente ad un catalogo specifico, usare Cataloghi > Utenti.",
  "USER_NEW_USER_ADD_USER_TO_ALL_CATALOGS": "Aggiungi utente a tutti i cataloghi come:",
  "USER_NO_USERS_SELECTED": "Nessun utente selezionato",
  "USER_ONLINE": "Online",
  "USER_PASSWORD_TOO_SHORT": "La password deve contenere almeno un carattere.",
  "USER_PASSWORDS_DO_NOT_MATCH": "Il campo di conferma password deve corrispondere al campo della password.",
  "USER_ROLE": "Livello di accesso",
  "USER_VIEW_DETAILS": "Visualizza/Modifica dettagli utente",
  "USERS": "Utenti",
  "VALIDATION_FIELD_LENGTH_EXCEEDED": "Questo campo non può superare i 255 caratteri.",
  "VALIDATION_MUST_BE_NONEMPTY": "Questo campo è obbligatorio.",
  "VIEW_EDIT_MAPPINGS": "Mostra / Modifica mappature",
  "General.OK": "OK",
  "General.Cancel": "Annulla",
  "PORT_TITLE": "Porte",
  "PORT_DEFAULT": "Predefinito:",
  "esp.port.admin-web-app": "Porta HTTP Admin Portfolio",
  "esp.port.admin-web-app-ssl": "Porta SSL Admin Portfolio",
  "esp.port.http": "Porta HTTP server Portfolio",
  "esp.port.ssl": "Porta SSL server Portfolio",
  "General.Save": "Salva",
  "CATALOG_DETAILS_FILETYPES_TAB": "Tipi di file",
  "addAsset": "Aggiungi risorse",
  "canManageFieldLists": "Gestisci Elenchi campo pubblico",
  "canModifyFolderStructure": "Modifica le strutture delle cartelle",
  "canMoveAssets": "Sposta risorse",
  "deleteAssetContents": "Elimina risorse originali",
  "deleteAssetFromCatalog": "Elimina risorsa dal catalogo",
  "modifyAssetProperties": "Aggiorna campi risorsa",
  "synchronizeAutoSyncFolder": "Cartelle Sync Autosync",
  "ASSETS": "Risorse",
  "CATALOG_STORAGE_TYPE_S3": "S3",
  "CREATE_CATALOG": "Creare catalogo",
  "STATUS_MSG_SYSTEM_MEMORY_BELOW_REQUIREMENTS": "La memoria di sistema è {value}GB che risulta al di sotto dei requisiti minimi di {minGB}GB",
  "STATUS_MSG_SYSTEM_MEMORY_POSSIBLY_INACCURATE": "La memoria di sistema calcolata dal Portfolio è di {value}GB che potrebbe risultare inaccurata.",
  "AUTH.couldNotConnect": "Impossibile collegarsi al server. Verificare l'indirizzo.",
  "ERROR.serverUnavailable": "Il server Portfolio non disponibile.",
  "ERROR.sessionExpired": "La tua sessione è scaduta.",
  "fileNotFound": "Il file non è stato trovato su disco.",
  "ERROR.invalidSearchFailed": "La ricerca è fallita in quanto si è verificato un problema con la richiesta.",
  "AUTH.loginFailed": "Nome utente e password errati.",
  "FAULT_CODE.InsufficientPrivileges": "Per eseguire questa operazione non si dispone dei privilegi sufficienti.",
  "unexpectedError": "Si è verificato un errore imprevisto.",
  "ROLES_CREATE_ROLE_TITLE": "Creare ruolo",
  "ROLES_DELETE_CONFIRM": "Si intende cancellare il ruolo selezionato?\nGli utenti con tale ruolo saranno declassati a lettori.",
  "NOTIFICATION_SUCCESS_UPDATE": "Aggiornamento avvenuto con successo",
  "DATA_COLLECTION_TITLE": "Analisi",
  "DATA_COLLECTION_RTI_OPT_OUT_LABEL": "Accetto di condividere i dati sull’utilizzo dell’applicazione.",
  "DATA_COLLECTION_RTI_OPT_OUT_TEXT": "Aiutaci a fornire le migliori soluzioni possibili condividendo l’uso dell’applicazione con noi.\n\nAccettando, ci aiuterai a raccogliere informazioni importanti che ci guideranno verso miglioramenti futuri in termini di qualità e funzionalità. I dati raccolti ci consentono di capire ciò che gli utenti si aspettano da una soluzione.\n\nPuoi sempre cambiare idea in qualsiasi momento e interrompere la condivisione delle tue informazioni.\n\nPer sapere di più su come utilizziamo le tue informazioni e per esercitare in futuro il diritto di opt-out, visita la pagina dell’articolo guida: ",
  "DATA_COLLECTION_HELP_URL": "https://help.portfoliodam.com/hc/it/articles/1260804371029",
  "CREATE_USER": "Crea utente",
  "CATALOG_FILES_TAB_TITLE": "Assimilare",
  "FIELD_CATEGORY_ALL": "Tutti i campi attivi",
  "FIELD_CATEGORY_FONTSENSE": "Portfolio DAM Font Sense",
  "FIELD_DEF.cataloged": "Catalogato",
  "FIELD_DEF.catalogedBy": "Catalogato da",
  "FIELD_DEF.colorMode": "Modalità colore",
  "FIELD_DEF.isPanoramic": "Panoramica",
  "FIELD_DEF.created": "Creato",
  "FIELD_DEF.directoryPath": "Percorso directory",
  "FIELD_DEF.documentText": "Testo documento",
  "FIELD_DEF.filename": "Nome file",
  "FIELD_DEF.fileDescription": "Descrizione",
  "FIELD_DEF.fileSize": "Dimensione file",
  "FIELD_DEF.geometry": "Geo - Programma",
  "FIELD_DEF.height": "Altezza",
  "FIELD_DEF.horizontalResolution": "Risoluzione orizzontale",
  "FIELD_DEF.keywords": "Parole chiave",
  "FIELD_DEF.lastModified": "Modificato",
  "FIELD_DEF.lastUpdated": "Cambiato",
  "FIELD_DEF.aliasMac": "Alias Mac",
  "FIELD_DEF.creatorMac": "Autore Mac",
  "FIELD_DEF.fileTypeMac": "Tipo di file Mac",
  "FIELD_DEF.zoneMac": "Zona Mac",
  "FIELD_DEF.multipageCount": "Numero pagine",
  "FIELD_DEF.numBands": "Numero delle fasce",
  "FIELD_DEF.path": "Percorso",
  "FIELD_DEF.ItemID": "ID risorsa",
  "FIELD_DEF.shortFilenameWin": "Nome file corto Win",
  "FIELD_DEF.thumbnailSize": "Formato miniatura",
  "FIELD_DEF.updatedBy": "Modificato da",
  "FIELD_DEF.verticalResolution": "Risoluzione verticale",
  "FIELD_DEF.volume": "Volume",
  "FIELD_DEF.watermarkURL": "URL filigrana",
  "FIELD_DEF.watermarked": "Filigranato",
  "FIELD_DEF.width": "Larghezza",
  "FIELD_DEF.SuggestedKeywords": "Smart Keywords",
  "REFRESH": "Aggiorna",
  "ALL_CATALOGS": "Tutti i cataloghi",
  "ALL_SITES": "Tutti i Site",
  "ASSET_DOWNLOADS": "Asset - maggiormente scaricati",
  "ASSET_PREVIEWS": "Asset - maggiormente visualizzati in anteprima",
  "ASSET_UPLOADS": "Asset - caricamenti",
  "DOWNLOAD_REPORT": "Download",
  "FILE_TYPES": "Tipi di file",
  "FILE_TYPES_SECTION_TITLE": "Tipi di file",
  "FILE_TYPES_ERROR_NAME_EXISTS": "Il nome '{name}' concorda con il nome di un tipo di file esistente.",
  "FILE_TYPES_LABEL_RESTORE_DEFAULTS": "Ripristina valori predefiniti",
  "FILE_TYPES_PROMPT_DISCARD_CHANGES": "Eliminare le modifiche in sospeso?",
  "FILE_TYPES_ADD_FILE_TYPE": "Aggiungi tipo di file",
  "FILE_TYPES_UPDATE_FILE_TYPE": "Aggiorna tipo di file",
  "FILE_TYPES_EXTENSIONS": "Estensioni",
  "FROM": "da",
  "SITE": "Site",
  "KEYWORD_STATISTICS": "Statistiche Parole chiave",
  "NETPUBLISH_MOST_DOWNLOADED": "NetPublish - Più Scaricato",
  "NETPUBLISH_USAGE": "NetPublish - Uso",
  "REPORT_DESCRIPTION_ASSET_PREVIEWS": "Tale report identifica quali asset siano stati visualizzati in anteprima e quante volte ognuno di questi sia stato visualizzato in anteprima.",
  "REPORT_DESCRIPTION_ASSET_UPLOADS": "Tale report identifica gli asset caricati, quali utenti li abbiano caricati e quando.",
  "REPORT_DESCRIPTION_DOWNLOADED": "Questo report identifica quali risorse sono state scaricate e quante volte al giorno sono state scaricate.",
  "REPORT_DESCRIPTION_KEYWORD": "Questo report identifica tutte le parole chiave in catalogo e a quante risorse si applicano.",
  "REPORT_DESCRIPTION_USAGE": "Questo report include quali utenti hanno scaricato risorse e quando.",
  "SEARCH_TERMS": "Termini di ricerca",
  "TO": "a",
  "VIEW_REPORT": "Visualizza report",
  "NP_SITES": "Siti NetPublish",
  "REPORT_NAME_DELETED_BY": "Asset - cancellazioni",
  "REPORT_NAME_DOWNLOADED_BY": "Asset - download",
  "REPORT_DESCRIPTION_DELETED_BY": "Tale report identifica gli asset modificati, quali utenti li abbiano cancellati e quando.",
  "REPORT_DESCRIPTION_DOWNLOADED_BY": "Tale report identifica gli asset scaricati, quali autenti li abbiano scaricati e quando.",
  "CATALOG_SAVE_TEMPLATE_TITLE": "Creazione modello catalogo",
  "BACKUP_FILES_LABEL": "File di backup",
  "CONFIGURE_EMAIL_LINK": "Configurazione notifiche email...",
  "NP_SOURCE": "Sorgente",
  "NOTIFICATION_FAILURE_UPDATE": "Aggiornamento avvenuto senza successo",
  "FIELD_FORM_LABEL_PRECISION_MAX": "Max",
  "REPORT_DESCRIPTION_FILE_TYPES": "Tale report identifica le tipologie di file più comuni e quanto spazio su disco viene occupato.",
  "REPORT_DESCRIPTION_SEARCH_TERMS": "Il presente report identifica le parole e le frasi più comuni per le quali gli utenti stanno svolgendo ricerche.",
  "DUPLICATE_FIELD_NAME_ERROR": "Nome campo duplicato",
  "NO_CATALOGS_EXIST": "Non esistono cataloghi.\n\nClicca sul pulsante + per creare un catalogo.",
  "CATALOG_CHANGE_LEVEL_FOR_SELECTED_USERS": "Cambia Ruolo",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_TITLE": "Cancelar socio",
  "REMOVE_USERS_FROM_CATALOG_CONFIRM_MSG": "Rimuovi l'utente dal catalogo?\nGli articoli Pagati dall’utente in questo catalogo saranno ripristinati e resi accessibili.",
  "CHANGE_USERS_ROLE_IN_CATALOG_CONFIRM_MSG": "Vuoi davvero modificare il ruolo dell'utente nel catalogo? Se il nuovo ruolo ha accesso o autorizzazioni ridotti, questa azione può essere distruttiva per i dati dell'utente.",
  "DIRECTORY_SERVICE_QUERY_PENDING_MESSAGE": "Interrogazione in corso... Questa operazione potrebbe richiedere alcuni minuti.",
  "FIELD_DELETE_CONFIRM_MSG": "Vuoi cancellare il campo selezionato?",
  "FILE_TYPES_PROMPT_RESTORE_DEFAULTS": "Ripristinare tutti i Tipi di file ai loro valori predefiniti?",
  "DIRECTORY_SERVICE_BROWSE_FILTER_LABEL": "Filtra",
  "DIRECTORY_SERVICE_BROWSE_ITEMS_LABEL": "AD utenti e gruppi",
  "DIRECTORY_SERVICE_SAVE_MAPPINGS": "Salva e sincronizza",
  "DIRECTORY_SERVICE_REMOVE_MAPPING": "Rimuovi mappatura",
  "DIRECTORY_SERVICE_MAPPING_SOURCE_LABEL": "Portfolio importazioni utente",
  "DIRECTORY_SERVICE_NO_MAPPINGS_LABEL": "Nessuna mappatura.\n\nPer crearne una, seleziona un utente o un gruppo a sinistra, quindi clicca su 'Crea Mappatura'.",
  "NOTIFICATION_FAILURE_ADD": "Aggiunta non riuscita",
  "FIELD_ADD_EXTRACT_METADATA": "Aggiungi Estrai mappatura",
  "FIELD_MULTIPLE_EMBED_WARNING": "Più di un campo si incorpora su",
  "CATALOG_SK_KEYWORD_ON_CATALOG_LABEL": "Smart Keyword per beni di recente catalogazione",
  "LIC_CLICK_TO_UPGRADE": "Cliccare per aggiornare Portfolio Server",
  "LIC_MAINTENANCE_END_DATE": "Data di fine della manutenzione / sottoscrizione",
  "LIC_SEAT_DISPLAY": "Postazioni utente",
  "LIC_ACTIVATE": "Attivare Portfolio (Credenziali Necessarie)",
  "LIC_CLICK_TO_ACTIVATE": "Cliccare per attivare Portfolio Server",
  "LIC_CLICK_TO_USE": "Cliccare per utilizzare Portfolio per un periodo di tempo limitato",
  "LIC_TRIAL": "Prova Portfolio (Numero di Serie Necessario)",
  "EXTENSIS_CONTACT_US_URL": "https://www.portfoliodam.com/contact-us-form?utm_source=internal-product-link&utm_medium=buy-upgrade-option",
  "EXTENSIS_SUPPORT_URL": "https://help.portfoliodam.com/hc/en-us/requests/new",
  "LIC_ERROR_GET_ACCOUNT": "Si è verificato un problema nell'ottenimento del tuo account Portfolio DAM.",
  "LIC_ERROR_GET_LICENSES": "Si è verificato un problema nel recupero delle tue licenze da Portfolio DAM.",
  "CHANGE": "Modifica",
  "GLOBAL_SETTINGS_FOLDER_SHUT_DOWN_MESSAGE": "Per modificare questa cartella, prima arresta Portfolio.",
  "MEDIA_ENGINES_COLUMN_TEST": "Testa",
  "ROLES_PERMISSIONS": "Autorizzazioni",
  "NO_SITES_EXIST_1": "Non esiste alcun sito NetPublish.",
  "NO_SITES_EXIST_2": "Utilizza l‘opzione Pubblica trovata in Portfolio per creare e pubblicare siti.",
  "MEDIA_ENGINE_NOT_OPERATIONAL": "Non è stato possibile accedere ai motori di ricerca mediatici.",
  "MEDIA_ENGINE_OPERATIONAL": "Media engine è operativo.",
  "LIC_SET_EXTENSIS_ACCOUNT": "Imposta account Portfolio DAM",
  "LIC_ACCOUNT": "Indirizzo e-mail",
  "LIC_PASSWORD": "Password",
  "CERTS_TITLE": "Certificato SSL",
  "LIC_SYSTEM_ID": "ID sistema",
  "LIC_SET_ACCOUNT_ERROR": "Si è verificato un problema nell'impostazione del tuo account Portfolio DAM. Controlla le credenziali e riprova.",
  "LIC_SET_SYSTEM_TITLE": "Seleziona il tuo sistema Portfolio DAM",
  "NP_DELETE_SITE_CONFIRMATION": "Vuoi eliminare definitivamente il sito?",
  "NP_SITE_DELETE_LABEL": "Elimina sito",
  "NP_SITE_ENABLED_LABEL": "Sito abilitato",
  "CERT_CREATE_REQUEST": "Crea una richiesta di certificato",
  "CERT_DOWNLOAD": "Scarica",
  "CERT_EXPIRATION_DATE": "Data di scadenza",
  "CERT_IMPORT": "Importa un certificato",
  "CERT_ISSUER": "Emittente",
  "CERT_OWNER": "Proprietario",
  "CERT_PENDING_REQUEST": "Richiesta di certificato in sospeso",
  "CERTIFICATE_STATUS_INVALID": "Certificato non valido",
  "CERTIFICATE_STATUS_SELF_SIGNED": "Certificato non valido: Auto-firmato",
  "CERTIFICATE_STATUS_EXPIRED": "Certificato scaduto",
  "CERTIFICATE_STATUS_IMPORTED": "Certificato importato",
  "CERT_DELETE_CONFIRMATION": "Sicuro di voler cancellare la richiesta di certificato? Azione irreversibile.",
  "DIAGNOSTICS_TITLE": "Diagnostica",
  "DIAGNOSTICS_NO_PROBLEMS": "Nessun problema riscontrato",
  "SK_ENGINE_ART_STYLE": "Stile artistico",
  "SK_ENGINE_ART_SUBJECT": "Soggetto artistico",
  "SK_ENGINE_ART_MOVEMENT": "Movimento artistico",
  "CERT_FILE": "File del certificato",
  "CERT_FILE_INT_1": "Certificato intermedio 1",
  "CERT_FILE_INT_2": "Certificato intermedio 2",
  "CERT_FILE_PASSWORD": "Password del certificato",
  "CERT_FILE_PASSWORD_HELP": "Se il tuo certificato è dotato di password, inseriscila qui",
  "CERT_FILE_PROMPT": "Seleziona...",
  "CERT_FILE_ROOT": "Certificato radice",
  "CERT_IMPORT_SUCCEEDED": "Il certificato è stato importato con successo. Riavvia il server Portfolio e i servizi di Admin Portfolio per iniziare ad usare il certificato.",
  "CERT_IMPORT_FAILED_READING_PKCS12": "Il server non è riuscito a leggere il certificato PKCS12. Controlla la password.",
  "CERT_IMPORT_FAILED_INTERMEDIATE1": "Impossibile importare il certificato Intermedio 1.",
  "CERT_IMPORT_FAILED_INTERMEDIATE2": "Impossibile importare il certificato Intermedio 2.",
  "CERT_IMPORT_FAILED_ROOT": "Impossibile importare il certificato radice.",
  "DIRECTORY_SERVICE_CONFIG_TITLE": "Configurazione del Servizio Directory",
  "DIRECTORY_SERVICES_TITLE": "Servizi Directory",
  "DIRECTORY_SERVICE_MAPIINGS": "Elementi della directory nelle mappature di Portfolio",
  "DIRECTORY_SERVICE_MAPIINGS_TITLE": "Mappature",
  "PDL_noPredefinedValues": "Nessun valore predefinito",
  "PDL_editPredefinedListPlaceholder": "Modifica la lista predefinita",
  "PDL_importPredefinedValues": "Importa valori predefiniti",
  "PDL_exportPredefinedValues": "Esporta i valori predefiniti",
  "PDL_removeNestedValueConfirmation": "Eliminare i valori selezionati?\nContengono valori nidificati che saranno altresì cancellati.",
  "PDL_wrongPdlImportFormat": "Il file selezionato non contiene dati di testo. Selezionare un file di testo.",
  "LIC_SET_ACCOUNT": "Imposta Account",
  "LIC_REMOVE_ACCOUNT": "Rimuovi l'Account",
  "LIC_CONTACT_CUSTOMER_SUCCESS_1": "Per assistenza con il rinnovo del tuo account, contattaci all'indirizzo",
  "LIC_CONTACT_CUSTOMER_SUCCESS_2": "e il tuo Customer Success Manager ti contatterà entro 1 giorno lavorativo."
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/translations/it.js